import liveInstructionRoute from './live-instruction';

export default [
  {
    path: '/reports',
    redirect: { name: 'reports.overview' },
    name: 'reports',
  },
  {
    path: '/reports/overview',
    name: 'reports.overview',
    component: () =>
      import(
        /* webpackChunkName: 'reports-overview' */
        '@/views/overview-report/OverviewReportView'
      ),
  },
  {
    path: '/reports/courses-units',
    name: 'reports.units_and_courses',
    component: () =>
      import(
        /* webpackChunkName: 'reports-courses-units' */
        '@/views/courses-units-report/CoursesUnitsReportView'
      ),
    redirect: { name: 'reports.units_and_courses.units' },
    children: [
      {
        path: '/reports/courses-units/courses',
        name: 'reports.units_and_courses.courses',
        component: () =>
          import(
            /* webpackChunkName: 'reports-courses-units' */
            '@/views/courses-units-report/CoursesReportView'
          ),
        meta: { isTimeZoneSensitive: true },
      },
      {
        path: '/reports/courses-units/units',
        name: 'reports.units_and_courses.units',
        component: () =>
          import(
            /* webpackChunkName: 'reports-courses-units' */
            '@/views/courses-units-report/UnitsReportView'
          ),
        meta: { isTimeZoneSensitive: true },
      },
    ],
  },
  liveInstructionRoute,
  {
    path: '/reports/session-report',
    name: 'reports.session',
    component: () =>
      import(
        /* webpackChunkName: 'reports-session' */
        '@/views/session-report/SessionReportView'
      ),
    meta: { isTimeZoneSensitive: true },
  },
  {
    path: '/reports/vpa',
    name: 'reports.vpa',
    component: () =>
      import(
        /* webpackChunkName: 'reports-vpa' */
        '@/views/vpa-report/VpaReportView'
      ),
    meta: { isTimeZoneSensitive: true },
  },
  // Access to these routes is gated by the backend feature flags:
  //   "reports.k12_school_enrollment" and "reports.k12_teacher_enrollment"
  // These must be enabled in the organization's command_center_features by the backend.
  // They are intended for K-12 organizations only — confirm backend configuration before release.
  {
    path: '/reports/k12-school-enrollment',
    name: 'reports.k12_school_enrollment',
    component: () =>
      import(
        /* webpackChunkName: 'reports-k12-school-enrollment' */
        '@/views/k12-enrollment-report/K12SchoolEnrollmentReportView'
      ),
    meta: { isTimeZoneSensitive: true },
  },
  {
    path: '/reports/k12-teacher-enrollment',
    name: 'reports.k12_teacher_enrollment',
    component: () =>
      import(
        /* webpackChunkName: 'reports-k12-teacher-enrollment' */
        '@/views/k12-enrollment-report/K12TeacherEnrollmentReportView'
      ),
    meta: { isTimeZoneSensitive: true },
  },
];
